import React, { forwardRef } from "react";

/** This person does not existのURL */
const randomHumanFaceImageUrl = "https://thispersondoesnotexist.com";

export { randomHumanFaceImageUrl };

function createRasterImageComponent(path: string) {
  return forwardRef<HTMLImageElement, React.ComponentPropsWithRef<"img">>(
    function RasterIcon(properties, forwardedRef) {
      return <img src={path} {...properties} ref={forwardedRef} />;
    },
  );
}

export const RandomHumanFaceImage = createRasterImageComponent(randomHumanFaceImageUrl);
